import styled, { css } from 'styled-components';

export const CorrectAnswers = styled.span(
  ({ theme }) => css`
    color: ${theme.co.success40};
    font-weight: ${theme.DEPRECATED_ty.bold};
  `,
);
